export const getColorsByLine = (name, lines) => {
  const line = lines.find((e) => e.name === name)?.color || "#34C759";

  const r = parseInt(line.slice(1, 3), 16);
  const g = parseInt(line.slice(3, 5), 16);
  const b = parseInt(line.slice(5, 7), 16);

  return {
    style: {
      backgroundColor: `rgba(${r}, ${g}, ${b}, 0.20)`,
      color: `rgb(${r}, ${g}, ${b})`,
    },
  };
};
